import { useTranslation } from 'react-i18next';

export default function FullCTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20charcoal%20dark%20backdrop%20with%20single%20beam%20of%20golden%20spotlight%20illuminating%20a%20curated%20arrangement%20of%20premium%20fashion%20pieces%2C%20rich%20velvet%20texture%20and%20metallic%20accessories%20catching%20the%20light%2C%20cinematic%20editorial%20photography%20with%20deep%20shadows%20and%20selective%20focus%2C%20luxurious%20mysterious%20atmosphere%20with%20warm%20bronze%20highlights&width=1600&height=900&seq=cta-full-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl lg:text-7xl font-heading font-bold text-background-50 mb-4 tracking-wide uppercase">
          {t('fullcta.title')}
        </h2>
        <p className="text-base md:text-lg text-background-50/80 mb-2">
          {t('fullcta.subtitle1')}
        </p>
        <p className="text-base md:text-lg text-background-50/80 mb-10">
          {t('fullcta.subtitle2')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-base md:text-lg font-semibold hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center -ml-2">
            <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center text-background-50"></i>
          </span>
          <span>{t('cta.kakobuySheet').toUpperCase()}</span>
          <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}